import numeral from 'numeral'

import { BankLine, Difference, DifferenceType } from '@modules-deprecated/bankReconciliation/types'

import { BillType } from '../../bills/enums/billType'
import { PayableSubjectType } from '../types/payableSubjectType'

interface IsBankFeeIncludedOptions {
  isBanklineValidForBankFee: boolean
  isSubjectBill: boolean
  isOverPayment: boolean
  isCreditNote?: boolean
}

const isBankFeeIncluded = ({
  isBanklineValidForBankFee,
  isSubjectBill,
  isOverPayment,
  isCreditNote,
}: IsBankFeeIncludedOptions): boolean => {
  if (!isBanklineValidForBankFee) {
    return false
  }
  // Bill
  if (isSubjectBill) {
    return isCreditNote ? !isOverPayment : isOverPayment
  }
  // Invoice
  return isCreditNote ? isOverPayment : !isOverPayment
}

interface GetSubjectReconciliationDifferenceOptions {
  bankLines?: BankLine[]
  subjectsAmount?: number
  subjectType?: PayableSubjectType
  reconciliationAmount?: number
  isCreditNote?: boolean
}

export const getSubjectReconciliationDifference = ({
  subjectType,
  bankLines,
  subjectsAmount,
  reconciliationAmount,
  isCreditNote,
}: GetSubjectReconciliationDifferenceOptions): Difference => {
  const differenceTypes: DifferenceType[] = []

  if (!reconciliationAmount || !subjectsAmount || !subjectType) {
    return {
      amount: 0,
      differenceAmount: 0,
      types: [],
    }
  }
  const isSubjectBill = subjectType === BillType.Bill
  const isBanklineValidForBankFee = !bankLines || bankLines.length === 1

  const isOverPayment = Math.abs(reconciliationAmount) > Math.abs(subjectsAmount)

  if (isOverPayment) {
    differenceTypes.push('overpayment')
  } else {
    differenceTypes.push('underpayment')
  }

  if (isBankFeeIncluded({ isBanklineValidForBankFee, isCreditNote, isOverPayment, isSubjectBill })) {
    differenceTypes.push('bankFee')
  }

  return {
    amount: subjectsAmount,
    differenceAmount: numeral(subjectsAmount).subtract(reconciliationAmount).value() || 0,
    types: differenceTypes,
  }
}
